var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row h-100 justify-content-center align-items-center bg-info text-light"},[_c('div',{staticClass:"col-sm-8 col-11"},[_c('h1',[_vm._v("Idea")]),_c('div',{staticClass:"col-sm-8 col-11"},[_vm._v(" Muchas gracias. ")]),_c('button',{staticClass:"btn w-100 btn-light btn-lg mt-4",on:{"click":_vm.start}},[_vm._v(" Otra idea ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }